import { getSelectedAccountInfo } from '@ibk/shared-auth';
import { baseApi } from '../api/baseApi';
export const creditApi = baseApi.injectEndpoints({
    endpoints: builder => ({
        getPartnerUrl: builder.query({
            query: ({ organizationDocumentNumber }) => ({
                url: '/v1/credit/partner-url',
                method: 'GET',
                params: { organizationDocumentNumber },
            }),
            transformResponse: (response) => {
                return response;
            },
            providesTags: ['Base'],
        }),
        getPartnerProfile: builder.query({
            query: ({ partner }) => {
                const partyId = getSelectedAccountInfo()?.targetId;
                return {
                    url: '/v1/invoice-financing/partner-profiles',
                    method: 'GET',
                    params: { partner },
                    ...(partyId && { headers: { 'party-id': partyId } }),
                };
            },
            keepUnusedDataFor: 0,
        }),
        getProductFaq: builder.query({
            query: productSlug => ({
                url: `/v1/products/${productSlug}/faq`,
                method: 'GET',
            }),
            transformResponse: (response) => response?.result?.content ?? [],
        }),
    }),
});
export const { useGetPartnerUrlQuery, useLazyGetPartnerUrlQuery, useGetPartnerProfileQuery, useGetProductFaqQuery } = creditApi;
